// eslint-disable-next-line boundaries/element-types
import { useIsEntitled } from 'features/authorization';
import { MCLASS_ASSET } from 'shared/config/entitelment-constants';
import { AuthService } from 'shared/lib/keycloak';

export const useIsMClassUserCheck = () => {
  const { isAssetFound: hasMClassAsset } = useIsEntitled(MCLASS_ASSET);

  const tokenParsed = AuthService.getParsedToken();
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const mclassUserSid = tokenParsed?.mclassUserSid;

  return !!mclassUserSid || hasMClassAsset;
};
